"use client"

import Heading from "@/app/(site)/_components/Atoms/Heading"
import StoryText from "@/app/(site)/_components/Atoms/Storytext"
import Text from "@/app/(site)/_components/Atoms/Text"
import { type RelatedArticles } from "@/types"
import React from "react"
import type { PortableTextBlock, PortableTextSpan } from "sanity"

type Props = {
    data: RelatedArticles
    isAboveTheFold?: boolean
    _type?: "technicalPointListBlock"
    title: string
    editorTitle: string
    list: {
        title: string
        description?: PortableTextBlock[]
    }[]
}

const TechnicalPointListBlock: React.FC<Props> = ({ data, isAboveTheFold }) => {
    const headingType = isAboveTheFold ? "h1" : "componentHeading"

    return (
        <div className="m-16 border-t-2 border-black py-32 md:m-24 md:py-56">
            <div className="grid grid-cols-2 pb-32 pt-24 md:pb-72">
                <div>
                    <Heading type={headingType} as="h2">
                        {data.title}
                    </Heading>
                </div>
            </div>

            <div className="mb-24 grid grid-cols-1 gap-24 md:mb-72 md:grid-cols-3">
                {/* List Column */}
                <div className="mt-24 md:col-span-2 md:col-start-2 md:mt-0">
                    <div className="grid grid-cols-1 gap-0 md:grid-cols-2 md:gap-24">
                        {Array.isArray(data?.list) &&
                            data?.list.length > 0 &&
                            data?.list.map((techList: RelatedArticles, index: number) => {
                                return (
                                    <div
                                        key={index}
                                        className="col-span-1 grid grid-cols-2 border-t border-black pb-24 pt-12 md:pb-48 md:pt-8"
                                    >
                                        <div className="col-span-2 mb-12 sm:col-span-1 md:mb-0">
                                            <Text size="medium" weight="regular">
                                                {techList.title}
                                            </Text>
                                        </div>
                                        <StoryText
                                            size="size4"
                                            className="col-span-2 sm:col-span-1"
                                        >
                                            {Array.isArray(techList.description) &&
                                                techList.description.length > 0 &&
                                                techList.description.map(
                                                    (
                                                        block: {
                                                            children: PortableTextSpan[]
                                                        },
                                                        blockIndex: number
                                                    ) => (
                                                        <React.Fragment key={blockIndex}>
                                                            {Array.isArray(
                                                                block.children as PortableTextSpan[]
                                                            ) &&
                                                                block.children.length >
                                                                    0 &&
                                                                block.children.map(
                                                                    (
                                                                        child,
                                                                        childIndex
                                                                    ) => (
                                                                        <React.Fragment
                                                                            key={
                                                                                childIndex
                                                                            }
                                                                        >
                                                                            {child.text}
                                                                        </React.Fragment>
                                                                    )
                                                                )}
                                                        </React.Fragment>
                                                    )
                                                )}
                                        </StoryText>
                                    </div>
                                )
                            })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TechnicalPointListBlock
